'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var parts = ['container'];
var baseStyle = {
  container: {
    mb: 5
  }
};
var Form = {
  parts: parts,
  baseStyle: baseStyle
};
exports["default"] = Form;